import RollHoverBtn from './RollHoverBtn';

export default RollHoverBtn;



// WEBPACK FOOTER //
// ./scripts/elements/RollHoverBtn/index.js